module["exports"] = [
  "კორპ. ##",
  "შენობა ###"
];



/*****************
 ** WEBPACK FOOTER
 ** ./~/faker/lib/locales/ge/address/secondary_address.js
 ** module id = 620
 ** module chunks = 0
 **/